(() => {
  if (customElements.get('teeez-hero')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class TeeezHero extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.ticking = false;

      this.setOffset();
      this.onResize = () => this.setOffset();
      window.addEventListener('resize', this.onResize, { passive: true });

      if (this.dataset.shrink === 'true') {
        const settle = () => requestAnimationFrame(() => setTimeout(() => this.classList.add('is-settled'), 2300));
        const first = this.querySelector('.teeez-hero__img');
        if (reduceMotion.matches || !first || (first.complete && first.naturalWidth)) settle();
        else {
          first.addEventListener('load', settle, { once: true });
          first.addEventListener('error', settle, { once: true });
          setTimeout(settle, 3500);
        }
      }

      if (this.slides.length > 1) this.setupSlides();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    /* Fill the screen below the header and announcement bar */
    setOffset() {
      let offset = 0;
      ['#shopify-section-announcement', '#shopify-section-header'].forEach((sel) => {
        const el = document.querySelector(sel);
        if (el) offset += el.getBoundingClientRect().height;
      });
      const top = this.getBoundingClientRect().top + window.scrollY;
      if (top < offset) offset = Math.max(0, top);
      this.startY = Math.max(0, top - offset);
      this.style.setProperty('--teeez-hero-offset', Math.round(offset) + 'px');
      if (!this.classList.contains('is-settled')) {
        const full = Math.max(window.innerHeight, (window.screen && window.screen.height) || 0) - this.getBoundingClientRect().top;
        this.style.setProperty('--teeez-hero-full', Math.ceil(full) + 'px');
        const hidden = Math.max(0, full - (window.innerHeight - this.getBoundingClientRect().top));
        this.style.setProperty('--teeez-hero-hidden', Math.ceil(hidden) + 'px');
      }
    }

    updateShrink() {
      if (reduceMotion.matches) {
        this.style.setProperty('--p', 0);
        return;
      }
      const h = this.offsetHeight || 1;
      const progress = Math.min(1, Math.max(0, (window.scrollY - (this.startY || 0)) / (h * 0.6)));
      this.style.setProperty('--p', progress.toFixed(3));
    }

    setupSlides() {
      const markInteracted = () => this.setAttribute('data-interacted', 'true');
      this.track.addEventListener('touchstart', markInteracted, { once: true, passive: true });
      this.track.addEventListener('wheel', markInteracted, { once: true, passive: true });

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
              const i = this.slides.indexOf(entry.target);
              this.dots.forEach((d, n) => d.setAttribute('aria-selected', n === i ? 'true' : 'false'));
              if (i > 0) markInteracted();
            }
          });
        },
        { root: this.track, threshold: [0.6] }
      );
      this.slides.forEach((s) => io.observe(s));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const i = parseInt(dot.dataset.dot, 10);
          this.goTo(i);
          markInteracted();
        });
      });

      this.track.addEventListener('keydown', (e) => {
        const current = this.dots.findIndex((d) => d.getAttribute('aria-selected') === 'true');
        if (e.key === 'ArrowRight') this.goTo(Math.min(this.slides.length - 1, current + 1));
        if (e.key === 'ArrowLeft') this.goTo(Math.max(0, current - 1));
      });
    }

    goTo(i) {
      this.track.scrollTo({
        left: this.slides[i].offsetLeft,
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    }
  }

  customElements.define('teeez-hero', TeeezHero);
})();
